function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.9 18.4c-.5 0-1 .2-1.4.5l-4.1-2.5v-.8l4.1-2.5c.4.3.9.5 1.4.5 1.3 0 2.4-1.1 2.4-2.4s-1.1-2.4-2.4-2.4-2.4 1.1-2.4 2.4v.4l-4.1 2.5c-.4-.3-.9-.5-1.4-.5-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4c.5 0 1-.2 1.4-.5l4.1 2.5v.4c0 1.3 1.1 2.4 2.4 2.4s2.4-1.1 2.4-2.4c0-1.4-1.1-2.4-2.4-2.4z",
    style: {
      fill: "#666"
    }
  }));
};
export default SvgShare;